// extracted by mini-css-extract-plugin
export default {"image":"_1Jj-2sd"};